// DO NOT CHANGE, WE RELY ON THIS DATA IN THIS FORMAT DOWNSTREAM
export const callVolumeOptions = ['1-10', '11-25', '26-50', '51-100', '100+'] as const;

// DO NOT CHANGE, WE RELY ON THIS DATA IN THIS FORMAT DOWNSTREAM
export const locationOptions = ['1', '2-5', '6-10', '11-20', '20+'] as const;

// DO NOT CHANGE, WE RELY ON THIS DATA IN THIS FORMAT DOWNSTREAM
export const revenueOptions = [
	'<100K',
	'100K-500K',
	'500K-1M',
	'1M-5M',
	'5M-10M',
	'10M-50M',
	'50M+',
	'private',
] as const;

export enum ReferralSource {
	Google = 'Google',
	ChatGPT = 'ChatGPT / AI',
	Facebook = 'Facebook',
	Instagram = 'Instagram',
	Youtube = 'Youtube',
	FriendOrColleague = 'Friend or Colleague',
	OneOfOurAIReceptionists = "One of our AI Receptionist's",
	Other = 'Other',
}

export const businessTypes = [
	{
		id: 'hvac',
		label: 'Field Service Contractors (HVAC/Plumbing/Electrical, etc.)',
		value: 'HVAC',
	},
	{ id: 'auto-sales', label: 'Auto Sales & Service' },
	{ id: 'auto-repair', label: 'Auto Repair' },
	{ id: 'car-dealership', label: 'Car Dealership' },
	{ id: 'other-automotive', label: 'Other Automotive Business' },
	{ id: 'beauty', label: 'Beauty' },
	{ id: 'construction', label: 'Construction' },
	{ id: 'retail', label: 'Retail' },
	{ id: 'food', label: 'Food' },
	{ id: 'legal', label: 'Legal' },
	{ id: 'marketing', label: 'Marketing' },
	{ id: 'technology', label: 'Technology' },
	{ id: 'entertainment', label: 'Entertainment' },
	{ id: 'real-estate', label: 'Real Estate' },
	{ id: 'other', label: 'Other' },
];

export type ECallVolume = (typeof callVolumeOptions)[number];
export type EBusinessLocations = (typeof locationOptions)[number];
export type EBusinessRevenue = (typeof revenueOptions)[number];
